import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

export const HOME_LCP_IMAGE = '/images/home-lcp-software.webp';
const HOME_LCP_WIDTH = 800;
const HOME_LCP_HEIGHT = 506;

const OptimizeRoutineTasks = ({ onConsultationClick }) => {
  const services = [
    {
      title: 'Лицензии и подписки на ПО',
      description:
        'Купить и продлить лицензии и подписки на программное обеспечение. Оплата в рублях со счёта компании, пакет закрывающих документов.',
      image: HOME_LCP_IMAGE,
      href: '/solutions',
      fetchPriority: 'high',
    },
    {
      title: 'AI-сервисы и Gen AI',
      description:
        'Лицензии на AI-продукты и сервисы для команд: облако и on-premise. Подбор, сравнение и поставка на аккаунт клиента.',
      image: '/images/home-lcp-ai.webp',
      href: '/gen-ai-creative',
    },
    {
      title: 'Каталог по задачам',
      description:
        'Решения по задачам бизнеса → вендоры и продукты. Откройте каталог или делегируйте закупку и продление менеджеру.',
      image: '/images/home-lcp-integration.webp',
      href: '/solutions',
    },
  ];

  useEffect(() => {
    const existing = document.head.querySelector(
      `link[rel="preload"][href="${HOME_LCP_IMAGE}"]`,
    );
    if (existing) return undefined;
    const link = document.createElement('link');
    link.rel = 'preload';
    link.setAttribute('as', 'image');
    link.href = HOME_LCP_IMAGE;
    link.setAttribute('fetchpriority', 'high');
    document.head.appendChild(link);
    return () => link.remove();
  }, []);

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <div className="max-w-3xl mb-12">
        <h1 className="text-4xl md:text-5xl font-bold mb-4 text-foreground leading-tight">
          Лицензии и подписки на ПО для компаний
        </h1>
        <p className="text-xl md:text-2xl text-foreground/90 mb-6 font-medium">
          Покупка, учёт и продление — в одном окне
        </p>
        <p className="text-base md:text-lg text-muted-foreground leading-relaxed mb-3">
          Антология — поставщик лицензий и подписок на программное обеспечение.
        </p>
        <p className="text-base md:text-lg text-muted-foreground leading-relaxed mb-8">
          Покупайте и продлевайте сами в сервисе учёта или делегируйте менеджеру в
          чате: КП, сравнение, оплата в рублях, закрывающие документы.
        </p>
        <div className="flex flex-wrap gap-3">
          <Button asChild size="lg" className="text-base px-6">
            <Link to="/solutions">Открыть каталог решений</Link>
          </Button>
          {typeof onConsultationClick === 'function' ? (
            <Button
              type="button"
              variant="outline"
              size="lg"
              className="text-base px-6"
              onClick={onConsultationClick}
            >
              Написать менеджеру
            </Button>
          ) : null}
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-8">
        {services.map((service) => (
          <Link
            key={`${service.href}-${service.title}`}
            to={service.href}
            className="block h-full rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2"
          >
            <Card className="h-full bg-card/50 border-border/50 hover:border-accent/50 transition-all duration-300 overflow-hidden group">
              <div className="relative h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  width={HOME_LCP_WIDTH}
                  height={HOME_LCP_HEIGHT}
                  fetchPriority={service.fetchPriority}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentElement.className =
                      'relative h-64 bg-gradient-to-br from-accent/10 to-transparent';
                  }}
                />
              </div>
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold mb-4 text-foreground">{service.title}</h3>
                <p className="text-base text-muted-foreground leading-relaxed">
                  {service.description}
                </p>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default OptimizeRoutineTasks;
